<template>
  <b-container>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <b-row>
        <b-col>
          <h4 style="text-align: center;">Location Setup</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2" order="2">
          <b-nav vertical class="pt-4 right-nav">
            <LocationList
              v-for="location of locations"
              :selectedlocatid=locat.id
              v-bind:location="location"
              v-bind:key="location.id"
              @locatemit="retrieveLocationDetails">
            </LocationList>
            <b-row>
              <b-col>
                <a :href="'#'+$route.path" class="h4 m-2">
                  <b-icon icon="plus-circle" variant="primary" v-b-popover.hover="'Add new location'" @click="showInputForm"></b-icon>
                </a>
              </b-col>
            </b-row>
          </b-nav>
        </b-col>

        <b-col cols="10" order="1">
          <b-form v-if="selectedlocat" class="mt-4">
          <!-- LOCATION NAME -->
            <b-row>
              <b-col>
                <b-form-group
                  id="locat_name"
                  :label="'Location name (ID: '+locat.id+')'"
                  label-for="locationname"
                  description="Enter a name for your location here"
                >
                  <b-form-input
                    id="locationname"
                    v-model="locat.name"
                    required
                    class="locatform"
                    @change="updateLocation()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

          <!-- TAX RATE -->
                <b-form-group
                  id="locat_tax_rate"
                  label="Tax Rate"
                  label-for="taxrate"
                  description="Enter tax rate"
                >
                  <b-form-input
                    id="taxrate"
                    v-model="locat.tax_rate.tax_rate"
                    required
                    class="locatform"
                    @change="updateTaxRate()"
                  >
                </b-form-input>
              </b-form-group>


          <!-- ORDER NUMBER PREFIX -->
            <!-- <b-row>
              <b-col>
                <b-form-group
                  id="locat_ordnum_prefix"
                  label="Order Number Prefix"
                  label-for="ordnumprefix"
                  description="If you require a custom prefix for your order numbers, enter it here"
                >
                  <b-form-input
                    id="ordnumprefix"
                    v-model="locat.order_num_prefix"
                    class="locatform"
                    @change="updateLocation()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row> -->

          <!-- ORDER NUMBER DIGITS -->
            <!-- <b-row>
              <b-col>
                <b-form-group
                  id="locat_ordnum_digits"
                  label="Order number digits"
                  label-for="ordnumdigits"
                  description="Specify number of digits in order number (default 7)"
                >
                  <b-form-select
                    id="ordnumdigits"
                    v-model="locat.order_num_digits"
                    :options="ordnumdigits"
                    class="locatform"
                    @change="updateLocation()"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row> -->

          <!-- NEXT ORDER NUMBER -->
            <!-- <b-row>
              <b-col>
                <b-form-group
                  id="locat_ordnum_next"
                  label="Next Order Number"
                  label-for="ordnumnext"
                  description="Next order number used by this location"
                >
                  <b-form-input
                    id="ordnumnext"
                    v-model="locat.next_order_num"
                    class="locatform"
                    @change="updateLocation()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row> -->
          </b-form>

          <!-- CAPACITY -->
          Order capacity
          <small class="form-text text-muted">Maximum number of orders to allow per timeslot increment</small>
          <b-form inline class="mb-3">
            <b-row>
              <b-col>
                <b-form-input
                  id="capacity"
                  v-model="locat.capacity"
                  class="locatform"
                  type="number"
                  @change="updateLocation()"
                  style="width: 5rem;"
                ></b-form-input> orders, every
                <b-form-input
                  id="timeslot_increment"
                  v-model="locat.timeslot_increment"
                  class="locatform"
                  type="number"
                  @change="updateLocation()"
                  style="width: 5rem;"
                ></b-form-input> minutes
              </b-col>
            </b-row>
          </b-form>

          <b-form>
            <!-- FIRST ORDER BUFFER -->
              <b-row>
                <b-col>
                  <b-form-group
                    id="locat_first_order_buffer"
                    label="First Order Buffer (mins)"
                    label-for="firstbuffer"
                    description="Minutes after opening to accept first order"
                  >
                    <b-form-input
                      id="firstbuffer"
                      v-model="locat.first_appt_buffer"
                      class="locatform"
                      @change="updateLocation()"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

          <!-- NEXT ORDER BUFFER -->
            <b-row>
              <b-col>
                <b-form-group
                  id="locat_next_order_buffer"
                  label="Next Order Buffer (mins)"
                  label-for="nextbuffer"
                  description="Minutes after current time to accept next order"
                >
                  <b-form-input
                    id="nextbuffer"
                    v-model="locat.next_appt_buffer"
                    class="locatform"
                    @change="updateLocation()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col>
                <b-form-group
                  id="locat_autoprint"
                  label="Auto Print Tickets"
                  label-for="autoprint"
                  description="Enable automatic ticket printing"
                >
                  <b-form-checkbox
                    id="autoprint"
                    v-model="locat.auto_print_tickets"
                    switch
                    class="locatform"
                    @change="validateCheckbox('auto_print_tickets')"
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  id="locat_star_id"
                  label="Star Printer ID"
                  label-for="starprintid"
                  :description="'Enter the Star Printer ID (Print Server URL: https://payoo-api.herokuapp.com/locations/'+locat.id+'/printqueue)'"
                >
                  <b-form-input
                    id="starprintid"
                    v-model="locat.star_unique_id"
                    class="locatform"
                    @change="updateLocation()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row cols="2" class="mt-2">
              <b-col>
                <b-form-group
                  id="locat_allow_appointments"
                  label="Allow appointments"
                  label-for="allow_appointments"
                  description="Enable Appoitnments"
                >
                  <b-form-checkbox
                    id="allow_appointments"
                    v-model="locat.allow_appointments"
                    switch
                    class="locatform"
                    @change="validateCheckbox('allow_appointments')"
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  id="locat_list_schedules"
                  label="Use List Schedules"
                  label-for="use_list_schedules"
                  description="Enable Item Scheduling"
                >
                  <b-form-checkbox
                    id="use_list_schedules"
                    v-model="locat.use_list_schedules"
                    switch
                    class="locatform"
                    @change="validateCheckbox('use_list_schedules')"
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col>
                <b-form-group
                  id="locat_allow_dinein"
                  label="Allow Dine In Orders"
                  label-for="allow_dinein"
                  description="Enable Dine In Orders"
                >
                  <b-form-checkbox
                    id="allow_dinein"
                    v-model="locat.allow_dinein"
                    switch
                    class="locatform"
                    @change="validateCheckbox('allow_dinein')"
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <hr>
            <h4>Delivery Options</h4>
            <b-row class="mt-2">
              <b-col>
                <b-form-group
                  id="locat_allow_delivery"
                  label="Allow Deliveries"
                  label-for="allow_delivery"
                  description="Enable Deliveries"
                >
                  <b-form-checkbox
                    id="allow_delivery"
                    switch
                    v-model="locat.allow_delivery"
                    class="locatform"
                    @change="validateCheckbox('allow_delivery')"
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row cols="2">
              <b-col>
                <b-form-group
                  id="locat_delivery_fee"
                  label="Delivery Fee"
                  label-for="delivery_fee"
                  description="Enter the additional fee for delivery"
                >
                  <b-form-input
                    id="locat_delivery_fee"
                    v-model="locat.delivery_fee"
                    class="locatform"
                    @change="updateLocation()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="locat_delivery_minimum"
                  label="Delivery Minimum Order"
                  label-for="delivery_minimum"
                  description="Enter the minimum order amount for deliveries"
                >
                  <b-form-input
                    id="locat_delivery_minimum"
                    v-model="locat.delivery_minimum"
                    class="locatform"
                    @change="updateLocation()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row cols="2">
              <b-col>
                <b-form-group
                  id="locat_delivery_range"
                  label="Delivery Range (miles)"
                  label-for="delivery_range"
                  description="Enter the range allowed for deliveries (in miles)"
                >
                  <b-form-input
                    id="locat_delivery_range"
                    v-model="locat.delivery_range"
                    class="locatform"
                    @change="updateLocation()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="locat_delivery_time"
                  label="Delivery Time Allowed"
                  label-for="delivery_time"
                  description="Enter the additional time to allow for deliveries (minutes)"
                >
                  <b-form-input
                    id="locat_delivery_time"
                    v-model="locat.delivery_time"
                    class="locatform"
                    @change="updateLocation()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row cols="2">
              <b-col>
                <b-form-group
                  id="locat_lat"
                  label="Latitude"
                  label-for="lat"
                  description="Enter latitude of the delivery location"
                >
                  <b-form-input
                    id="locat_lat"
                    v-model="locat.lat"
                    class="locatform"
                    @change="updateLocation()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="locat_long"
                  label="Longitude"
                  label-for="long"
                  description="Enter longitude of the delivery location"
                >
                  <b-form-input
                    id="locat_long"
                    v-model="locat.long"
                    class="locatform"
                    @change="updateLocation()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row><b-col>Click <b-link href="https://developer.mapquest.com/documentation/tools/latitude-longitude-finder/" target="_blank" rel="noopener noreferrer">here</b-link> to get the Lat / Long for your delivery center.</b-col></b-row>

            <!-- ACTIVE -->
            <b-row class="mt-2">
              <b-col>
                <b-form-group
                  id="locat_active"
                  label="Active"
                  label-for="activelocat"
                  description="Set location as active / inactive"
                >
                  <b-form-checkbox
                    id="activelocat"
                    v-model="locat.active"
                    switch
                    class="locatform"
                    @change="validateCheckbox('active')"
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button v-if="newLocat" id="addlocat" variant="dark" @click="addNewLocation()">Add</b-button>
              </b-col>
            </b-row>
          </b-form>

          <div class="mt-4 mb-4">
            <b-tabs content-class="mt-3" justified>
              <b-tab title="Addresses" active>
                <b-list-group>
                  <b-list-group-item>
                    <b-row>
                      <b-col cols="6">Address</b-col>
                      <b-col cols="3">Address Type</b-col>
                    </b-row>
                  </b-list-group-item>
                  <b-list-group-item>
                    <AddAddress
                      v-bind:vendor_id="locat.vendor_id"
                      @emit-switch-overlay="switchOverlay"
                      @emit-update-entity="addAddressToLocation"
                    ></AddAddress>
                  </b-list-group-item>
                  <AddressList
                    v-for="address in locat.location_addresses"
                    v-bind:address="address"
                    v-bind:key="address.id"
                    v-bind:vendor_id="locat.vendor_id"
                    @emit-switch-overlay="switchOverlay"
                    @emit-fetch-entity="retrieveLocationDetails"
                    @remove-address-from-entity="removeAddressFromLocation">
                  </AddressList>
                </b-list-group>
                <b-row>
                  <b-col cols="2"></b-col>
                  <b-col>
                    <b-button variant="primary" @click="copyAddressesFromVendor()">Use Vendor Addresses</b-button>
                  </b-col>
                </b-row>

              </b-tab>
              <b-tab title="Opening Hours">
                <b-row>
                  <b-col cols="1"></b-col>
                  <b-col>Open Time</b-col>
                  <b-col>Close Time</b-col>
                  <b-col>Day</b-col>
                </b-row>
                <b-row style="width:100%;">
                  <b-col cols="1">
                    <a :href="'#'+$route.path"><b-icon icon="plus-circle" variant="primary" font-scale="1.5" shift-v="-4" v-b-popover.hover.left="'Add Hours'" @click="addOpeningHours()"></b-icon></a>
                  </b-col>
                  <b-col>
                    <b-form-timepicker v-model="ophour.open_time" hour12></b-form-timepicker>
                  </b-col>
                  <b-col>
                    <b-form-timepicker v-model="ophour.close_time" hour12></b-form-timepicker>
                  </b-col>
                  <b-col>
                    <b-form-select v-model="ophour.day" :options="days"></b-form-select>
                  </b-col>
                </b-row>
                <b-form inline>
                  <OpeningHours
                    v-for="hour of hours"
                    v-bind:hour="hour"
                    v-bind:key="hour.id"
                    :days="days"
                    @update-hours-emit="updateOpeningHours"
                    @delete-hours-emit="deleteOpeningHours"
                  ></OpeningHours>
                </b-form>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import LocationList from '@/components/LocationList.vue'
import OpeningHours from '@/components/OpeningHours.vue'
import AddressList from '@/components/AddressList.vue'
import AddAddress from '@/components/AddAddress.vue'

export default {
  name: "Locations",
  components: {
    LocationList,
    OpeningHours,
    AddressList,
    AddAddress
  },
  data() {
    return {
      locations: [],
      ordnumdigits: [5,6,7,8,9],
      firstlocat: 0,
      selectedlocat: [],
      newLocat: false,
      activLocation: true,
      showoverlay: false,
      locat: {
        name: "",
        tax_rate: {
          id: null,
          name: null
        },
        order_num_prefix: "",
        order_num_digits: 7,
        next_order_num: 1,
        capacity: 0,
        timeslot_increment: 0,
        first_appt_buffer: 0,
        next_appt_buffer: 0,
        auto_print_tickets: false,
        star_unique_id: '',
        use_list_schedules: false,
        allow_dinein: false,
        allow_appointments: false,
        allow_delivery: false,
        delivery_fee: 0.00,
        delivery_range: 0,
        delivery_time: 0,
        delivery_minimum: 0.00,
        lat: 0.00,
        long: 0.00,
        active: true
      },
      hours: [],
      ophour: {
        open: '',
        close: '',
        day: 0
      },
      days: [
        {value: null, text: '--Choose Day--'},
        {value: 0, text: 'Monday'},
        {value: 1, text: 'Tuesday'},
        {value: 2, text: 'Wednesday'},
        {value: 3, text: 'Thursday'},
        {value: 4, text: 'Friday'},
        {value: 5, text: 'Saturday'},
        {value: 6, text: 'Sunday'}
      ],
    };
  },

  computed: {
    locat_addr: function() {
      if (this.locat.location_addresses) {
        return this.locat.location_addresses.map(addr => addr.id);
      } else {
        return [];
      }
    },
  },

  methods: {
    async copyAddressesFromVendor() {
      // pull ownvendor
      this.showoverlay = true;
      const token = await this.$auth.getTokenSilently();
      const { data } = await this.$api.get("ownvendor", {
        headers: { Authorization: `Bearer ${token}` }
      });
      const vend_addr = await data.vendor.address.map(addr => addr.id);
      console.log(vend_addr);
      // send vendor addresses to patch location
      this.updateLocation(vend_addr);
    },

    switchOverlay(bool) {
      this.showoverlay = bool;
    },

    addAddressToLocation(address_id) {
      // address_added in component. Add new address to vend_addr and trigger update
      this.locat_addr.push(address_id);
      this.updateLocation(this.locat_addr);
    },

    removeAddressFromLocation(address_id) {
      // remove id from locat_addr, then update
      const addr_idx = this.locat_addr.indexOf(address_id);
      this.locat_addr.splice(addr_idx, 1);
      this.updateLocation(this.locat_addr);
    },

    async fetchLocations() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      await this.$api.get("locations", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      }).then(response=> {
        if (response.data.success==true) {
          this.locations = response.data.locations;
          var sortedlocations = this.locations.sort((a,b) => a.id - b.id);
          this.firstlocat = sortedlocations[0].id;
          this.retrieveLocationDetails(this.firstlocat);
          this.fetchOpeningHours();
        } else {
          this.newLocat=true;
          this.showoverlay=false;
        }
      })
      .catch(error => {
        console.log(error)
        this.showoverlay=false;
      })
    },

    async fetchOpeningHours() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("locations/"+this.firstlocat+"/openinghours", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.hours = await data.hours;
    },

    async retrieveLocationDetails(locatid=this.locat.id) {
      // this.editmode='read';
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("locations/"+locatid, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.locat = data.location;
      this.locat.tax_rate = data.location.tax_rate;
      this.newLocat = false;
      this.showoverlay = false;
    },

    showInputForm() {
      this.locat = {
        name: "",
        tax_rate: {
          id: null,
          name: null
        },
        order_num_prefix: "",
        order_num_digits: 7,
        next_order_num: 1,
        active: true,
        location_addresses: [],
        capacity: 0,
        timeslot_increment: 0,
        first_appt_buffer: 0,
        next_appt_buffer: 0,
        auto_print_tickets: false,
        star_unique_id: '',
        use_list_schedules: false,
        allow_dinein: false,
        allow_appointments: false,
        allow_delivery: false,
        delivery_fee: 0.00,
        delivery_range: 0,
        delivery_time: 0,
        delivery_minimum: 0.00,
        lat: 0.00,
        long: 0.00,
      };
      this.newLocat = true;
    },

    sendRequest() {
      if (this.editmode=='new') {
        this.addNewLocation();
      } else if (this.editmode=='edit') {
        this.updateLocation();
      }
    },

    async prepRequestHeaders() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      return config;
    },


    async createTaxRate() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "taxrate": this.locat.tax_rate.tax_rate,
        "locat_name": this.locat.name
      };
      const { data } = await this.$api.post('taxrates',
        body,
        config
      );
      if (data.created == true) {
        return data.new_id;
        // this.retrieveLocationDetails(this.locat.id);
      } else {
        this.$bvModal.msgBoxOk('There was a problem creating the tax rate, please try again later.', {
          title: 'Error creating tax rate',
          centered: true
        })
      }
    },

    async addNewLocation() {
      var taxrate_id = await this.createTaxRate();
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = this.locat;
      body['tax_rate']=taxrate_id;
      // update order with status of 'ready'
      const { data } = await this.$api.post('locations',
        body,
        config
      );
      if (data.created == true) {
        this.fetchLocations();
        this.$bvModal.msgBoxOk('New Location Created.', {
          title: 'Success!',
          centered: true
        })
      } else {
        this.$bvModal.msgBoxOk('There was a problem creating your new location, please try again.', {
          title: 'Error creating location',
          centered: true
        })
      }
    },
    
    async updateLocation(location_address=this.locat_addr) {
      if (this.newLocat==true) {
        return;
      }
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = this.locat;
      body['location_address']=location_address;
      body['tax_rate']=this.locat.tax_rate.id;
      const { data } = await this.$api.patch('locations/'+this.locat.id,
        body,
        config
      );
      if (data.success == true) {
        this.retrieveLocationDetails();
      } else {
        this.$bvModal.msgBoxOk('There was a problem updating the location, please try again.', {
          title: 'Error updating location',
          centered: true
        })
      }
    },

    async addOpeningHours() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = this.ophour;
      const { data } = await this.$api.post('locations/'+this.locat.id+'/openinghours',
        body,
        config
      );
      if (data.created == true) {
        this.fetchOpeningHours();
      } else {
        this.$bvModal.msgBoxOk('There was a problem adding the hours, please try again later.', {
          title: 'Error adding hours',
          centered: true
        })
      }
    },

    async updateOpeningHours(hours) {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = hours;
      const { data } = await this.$api.patch('openinghours/'+hours.id,
        body,
        config
      );
      if (data.updated == true) {
        this.fetchOpeningHours();
      } else {
        this.$bvModal.msgBoxOk('There was a problem updating the hours, please try again later.', {
          title: 'Error updating hours',
          centered: true
        })
      }
    },

    async deleteOpeningHours(id) {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      const { data } = await this.$api.delete('openinghours/'+id,
        config
      );
      if (data.deleted == true) {
        this.fetchOpeningHours();
      } else {
        this.$bvModal.msgBoxOk('There was a problem deleting the hours, please try again later.', {
          title: 'Error deleting hours',
          centered: true
        })
      }
    },

    async updateTaxRate() {
      if (this.newLocat==true) {
          this.addNewLocation();
          return;
      }

      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "taxrate": this.locat.tax_rate.tax_rate
      };
      const { data } = await this.$api.patch('taxrates/'+this.locat.tax_rate.id,
        body,
        config
      );
      if (data.success == true) {
        this.retrieveLocationDetails(this.locat.id);
      } else {
        this.showoverlay = false;
        this.$bvModal.msgBoxOk('There was a problem updating the tax rate, please try again later.', {
          title: 'Error updating tax rate',
          centered: true
        })
      }
    },
       validateCheckbox(model) {
        // store the original value of the switch box using the variable v-model name
        var origSwitchValue = this.locat[model]
        // this function just show dialog and update the specific data
        this.$bvModal.msgBoxConfirm('Are you sure?')
        .then(value => {
        if (value == true) {
           this.locat[model] =  !origSwitchValue ;
          // if you confirmed the change, proceed to updateLocation()
           this.updateLocation();
        } else {
          // if you cancel - revert the v-model back to the original value on the display and do not updateLocation()
          this.locat[model] = origSwitchValue
        }
        })
        .catch(err => {
          console.error(err) ;
        });
    },
  },
  created: function() {
    this.fetchLocations();
  }
}
</script>
